import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuService } from '@core/services/menu.service';
import { CommonFunctions } from '@shared/common-functions';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-driver-created-sucess',
  templateUrl: './driver-created-sucess.component.html',
  styleUrls: ['./driver-created-sucess.component.scss']
})
export class DriverCreatedSucessComponent implements OnInit {
  role: string = '';
  roleRoute: string = '';
  isDispatcher: boolean;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly router: Router,
    public readonly config: DynamicDialogConfig,
    public readonly menuService: MenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit() {
    this.role = this.encryptStorage.getItem('roleName');
    this.isDispatcher = this.config.data.isDispatcher;
    this.roleRoute = CommonFunctions.routeToBookingDetail(this.role);
  }

  cancelDialog(): void {
    this.ref.close();
      this.router.navigate([`${this.roleRoute}/user-database-list`]);
    } 
}
